// Shown when edge functions return 401 even after token refresh.
// Listens to the 'auth:session-expired' custom event dispatched by safeInvoke.ts.

import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useNavigate } from 'react-router-dom';

export function SessionExpiredBanner() {
  const [visible,    setVisible]    = useState(false);
  const [signingOut, setSigningOut] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    function handler() { setVisible(true); }
    window.addEventListener('auth:session-expired', handler);
    return () => window.removeEventListener('auth:session-expired', handler);
  }, []);

  if (!visible) return null;

  async function handleSignOut() {
    setSigningOut(true);
    await supabase.auth.signOut();
    navigate('/login');
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '1.5rem',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9999,
      backgroundColor: 'rgba(15,17,30,0.97)',
      border: '1px solid rgba(31,78,95,0.4)',
      borderRadius: 'var(--radius-md)',
      padding: '0.875rem 1.25rem',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
      maxWidth: 'min(480px, 92vw)',
    }}>
      <span style={{ fontSize: '1.25rem', flexShrink: 0 }}>🔑</span>
      <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-caption)', margin: 0, lineHeight: 1.5 }}>
        Sua sessão expirou. Por favor, entre novamente para continuar.
      </p>
      <button
        className="btn btn-primary btn-sm"
        onClick={handleSignOut}
        disabled={signingOut}
        style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
      >
        {signingOut ? '…' : 'Entrar'}
      </button>
    </div>
  );
}
